module.exports = __webpack_public_path__ + "static/img/7.cc657ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/5/7.png
// module id = 252
// module chunks = 0